import React, { cloneElement, useCallback, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const AntTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
        backgroundColor: '#52BA50',
    },
    '& .MuiTabs-scrollButtons.Mui-disabled': {
        opacity: '0.3'
    }
});

const AntTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    color: 'black',
    '&:hover': {
        color: '#52BA50',
        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#52BA50',
        fontWeight: 600,
    },
    '&.Mui-focusVisible': {
        backgroundColor: '#d1eaff',
    },
}));

function TabPanel(props) {
    const { children, value, index, keepEverythingMounted, ...other } = props;
    return (
        <div
            role='tabpanel'
            // hidden={value !== index}
            id={`simple-tabpanel-calidad-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {!keepEverythingMounted && value === index && <>{children}</>}
            {keepEverythingMounted && <Box sx={{ display: value === index ? 'block' : 'none' }}>
                {children}
            </Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-calidad-${index}`,
    };
}

export default function CustomTabs({
    tabs,
    currentTabIndex,
    initialTabIndex,
    mustDisabledFutureTabs,
    handleChangeTab,
    ariaLabelTabs,
    ...props
}) {

    const disableFutureTabs = (tabIndex) => {
        return mustDisabledFutureTabs && (tabIndex > initialTabIndex);
    }

    return (
        <AntTabs
            {...props}
            value={currentTabIndex}
            onChange={(_, tabIndex) => handleChangeTab(tabIndex)}
            variant='scrollable'
            aria-label={ariaLabelTabs}
        >
            {tabs.map((tab, index) => (
                <AntTab
                    key={`tabName-${tab.name}-index-${index}`}
                    disabled={disableFutureTabs(index) || tab.disabled}
                    label={tab.name}
                    {...a11yProps(index)}
                />
            ))}
        </AntTabs>
    )
}

export function TabPanels({
    tabs,
    currentTabIndex,
    initialTabIndex,
    handleStageChange,
    keepEverythingMounted,
    ...props
}) {

    const onChange = useCallback((changes, tabIndex) => {
        handleStageChange(tabIndex + 1, changes)
    }, [handleStageChange]);

    return (
        <Box>
            {tabs.map((tab, tabIndex) => (
                <TabPanel
                    value={currentTabIndex}
                    index={tabIndex}
                    keepEverythingMounted={keepEverythingMounted}
                    key={`current-tab${currentTabIndex}-index-${tabIndex}`}
                    disabled={tab.disabled}
                >
                    {cloneElement(tab.component, {
                        ...props,
                        onChange: (changes) => onChange(changes, tabIndex),
                        tab,
                    })}
                </TabPanel>
            ))}
        </Box>
    )
}